import type {CourseApiModel} from '../../../api/course';
import type {
  BaseTaskApiModel,
  ClientTaskApiModel,
  CoachTaskApiModel,
} from '../../../api/task/types';
import type {Nullable} from '../../utility-types';

import {isClientOrCoachTask} from './isTask';

type TargetEntity = Nullable<
  (BaseTaskApiModel | ClientTaskApiModel | CoachTaskApiModel) & {
    course?: Nullable<CourseApiModel>;
  }
>;

export const isTaskSuspended = (entity?: TargetEntity) => {
  if (isClientOrCoachTask(entity)) {
    return entity.status === 'suspended';
  }

  return false;
};
